import { Trees, Users, Moon } from "lucide-react";

const HighlightBadgesSection = () => {
  const highlights = [
    {
      icon: Trees,
      title: "Private River Beach",
      description: "Your own peaceful corner of the San Marcos",
    },
    {
      icon: Users,
      title: "Welcoming Family Atmosphere",
      description: "Reconnect with the people who matter most",
    },
    {
      icon: Moon,
      title: "Restful Evenings",
      description: "Air-Conditioned Cabins & Quiet hours from 11pm so everyone sleeps well",
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-forest/5">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {highlights.map((highlight, index) => (
            <div
              key={index}
              className="text-center p-6 rounded-2xl bg-background border border-forest/10 shadow-sm"
            >
              <div className="w-14 h-14 rounded-full bg-forest/10 flex items-center justify-center mx-auto mb-4">
                <highlight.icon className="h-7 w-7 text-forest" />
              </div>
              <h3 className="font-heading text-xl font-semibold text-brown mb-2">
                {highlight.title}
              </h3>
              <p className="text-muted-foreground">
                {highlight.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HighlightBadgesSection;
